import { getStore } from "app/store/store"
import { ISsp } from "ssp/model"

export const searchSspsByName = async (filter: string): Promise<ISsp[]> => {
  const lowerCaseFilter = filter.toLowerCase()
  return getStore().getState().ssp.ssps.filter(ssp => ssp.name.toLowerCase().includes(lowerCaseFilter))
}
